/**
 * Set Third Part Attach list
 * @param {Array} payload - Third Part Attach Objects List.
 */
export const set = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(payload)) reject(new Error(`${payload} must be an array`))
    Promise.all(
      payload.map(item => dispatch('addItem', item))
    ).then(() => {
      resolve()
    }, (err) => {
      reject(err)
    })
  })
}

/**
 * Add Third Part Attach
 * @param {Object} payload - Third Part Attach Object.
 */
export const addItem = ({ commit }, payload) => {
  return new Promise((resolve) => {
    commit('ADD', Object.assign({}, payload))
    resolve()
  })
}

export const editItem = ({ commit }, { index, value }) => {
  return new Promise((resolve) => {
    commit('EDIT', {
      index,
      value: Object.assign({}, value)
    })
    resolve()
  })
}

export const removeItem = ({ commit }, index) => {
  return new Promise((resolve) => {
    commit('REMOVE', index)
    resolve()
  })
}

export const empty = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LIST', [])
    resolve()
  })
}
